import { FranchiseType } from "@hubcapp/types";

import { PageType } from "./types";

export const shouldDisplayPage = (
  pageType: PageType,
  propositionTypes: FranchiseType[],
) => {
  switch (pageType) {
    case PageType.Calendar:
    case PageType.AddLearner:
    case PageType.EditLearner:
    case PageType.ViewLearner:
    case PageType.ViewLearners:
    case PageType.News:
    case PageType.TechUpdates:
    case PageType.AreasCovered:
    case PageType.ManageArea:
    case PageType.AddANewArea:
    case PageType.Preferences:
      return Boolean(
        propositionTypes.filter(pt => pt !== FranchiseType.Solo).length,
      );
    case PageType.Messages:
    case PageType.News:
    case PageType.TechUpdates:
    case PageType.MyBusinessProfile:
      return Boolean(
        propositionTypes.filter(
          pt => pt !== FranchiseType.Solo && pt !== FranchiseType.ThirdParty,
        ).length,
      );
  }

  return true;
};
